import React, { CSSProperties, ReactNode } from "react"

export interface Tilt3DLayerProps {
  children: ReactNode
  /** Distance de décollement (unité CSS, ex. « 2.5rem ») */
  depth?: string
  className?: string
}

const DEFAULT_DEPTH = "2rem"

/**
 * Calque décollé en profondeur à l'intérieur d'un `Tilt3D` : il semble flotter
 * au-dessus du contenu quand celui-ci s'incline.
 * Chaque élément entre `Tilt3D` et ce calque doit avoir `transform-style: preserve-3d`.
 * Styles définis dans Tilt3D/style.scss.
 */
const Tilt3DLayer = ({
  children,
  depth = DEFAULT_DEPTH,
  className,
}: Tilt3DLayerProps) => (
  <div
    className={`clux-tilt-3d-layer${className ? ` ${className}` : ""}`}
    style={{ "--clux-tilt-depth": depth } as CSSProperties}
  >
    {children}
  </div>
)

export default Tilt3DLayer
